export default function Marquee({ items }) {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div className="overflow-hidden border-y border-border bg-muted/50 py-5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {doubled.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl text-foreground/60 px-6">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-accent/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
